<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div id="vn-1">
                    <h1>1. Bắt đầu khoá học</h1>
                </div>
                <div>
                    <p>① Chọn một khóa học bạn muốn học.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_1.png" alt="" /></div>
                <div>
                    <p>※ Sau khi tìm được khóa học mà bạn muốn học, thì nhấn vào khóa học đó để di chuyển đến màn hình khái quát khóa học.</p>
                    <p>② Ở màn hình Khái quát khóa học, nhấn nút [Bắt đầu], di chuyển đến màn hình [Mục lục khóa học].</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_2.png" alt="" /></div>
                <div id="vn-2">
                    <h1>2. Chọn bài học</h1>
                </div>
                <div>
                    <p>① Nhấn vào 1 bài học trong Mục lục bài học, rồi học nội dung bài học đó.</p>
                    <p>※ Icon quyển sách bên tên bài học hiển thị màu đen là chưa học, màu đỏ là đang học và mày xanh là đã học xong bài.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_3.png" alt="" /></div>
                <div id="vn-3">
                    <h1>3. Di chuyển nội dung lên・xuống</h1>
                </div>
                <div>
                    <p>※ Trường hợp hình ảnh hiển thị không hết trong trang bạn có thể chọn thanh bên phải để di chuyển lên hoặc xuống để xem ảnh.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_4.png" alt="" /></div>
                <div id="vn-4">
                    <h1>4. Phóng to/Thu nhỏ</h1>
                </div>
                <div>
                    <p>※ Trường hợp không thể nhìn thấy rõ thông tin hình ảnh, bạn có thể phóng to hoặc thu nhỏ ở icon phía trên.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_5.png" alt="" /></div>
                <div id="vn-5">
                    <h1>5. Ghi chú</h1>
                </div>
                <div>
                    <p>① Chọn phần ghi chú.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_6.png" alt="" /></div>
                <div>
                    <p>② Điền nội dung cần ghi chú.</p>
                    <p>③ Sau khi hoàn tất việc ghi chú hãy nhấn nút [lưu].</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_7.png" alt="" /></div>
                <div id="vn-6">
                    <h1>6. Trao đổi ý kiến</h1>
                </div>
                <div>
                    <p>① Chọn phần trao đổi.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_8.png" alt="" /></div>
                <div>
                    <p>② Tại đây bạn có thể gửi câu hỏi liên quan đến bài học đang học cho giáo viên.</p>
                    <p>※ Ngoài gửi câu hỏi cho giáo viên còn xem được nội dung trao đổi của các học viên khác về nội dung bài học liên quan.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_9.png" alt="" /></div>
                <div id="vn-7">
                    <h1>7. Di chuyển trang</h1>
                </div>
                <div>
                    <p>※ Nhấn icon [Về trước], [Đi tiếp] để di chuyển để trang tiếp theo hoặc quay lại trang trước.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_10.png" alt="" /></div>
                <div id="vn-8">
                    <h1>8. Làm bài tập</h1>
                </div>
                <div>
                    <p>※ Lưu ý: Phải xem hết tất cả nội dung của bài học thì mới có thể làm bài tập của bài học đó. Nếu chưa hoàn thành nội dung bài học mà nhấn vào icon [Bài tập], hộp thoại cảnh báo sẽ xuất hiện.</p>
                    <p>① Biểu tượng Bài tập sẽ được hiển thị ở cột Bài tập trong mỗi bài học. Khi nhấn biểu tượng Bài tập, thì sẽ di chuyển đến màn hình làm Bài tập.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_11.png" alt="" /></div>
                <div>
                    <p>② Hoặc có thể làm bài tập từ trang bài học cụ thể bằng cách nhấn vào biểu tượng Bài tập ở góc phải phải phía trên màn hình.</p>
                    <p>※ Nếu không có biểu tượng bài tập thì có nghĩa là bài học đó không có bài tập.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_12.png" alt="" /></div>
                <div>
                    <p>③ Nhấn vào nút [Cần xem lại] nếu bạn chưa chắc chắn với câu hỏi này.</p>
                    <p>④ Chọn đáp án đúng vào câu hỏi bạn cần trả lời.</p>
                    <p>⑤ Nhấn icon [Đi tiếp], [về tiếp] để di chuyển câu tiếp theo hoặc quay lại câu hỏi trước.</p>
                    <p>⑥ Hiển thị danh sách câu hỏi. Câu đang có viền màu đỏ là câu hiện tại bạn đang làm. Câu được tô màu xanh là những câu bạn đã điền đáp án.</p>
                    <p>⑦ Hiển thị danh sách những câu bạn cần xem lại.</p>
                    <p>⑧ Nhấn nút hiển thị toàn bộ sẽ hiển thị toàn bộ câu hỏi trong bài luyện tập.</p>
                    <p>⑨ Nhấn nút nộp bài để nộp bài luyện tập.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_13.png" alt="" /></div>
                <div id="vn-9">
                    <h1>9. Xem điểm bài tập</h1>
                </div>
                <div>
                    <p>※ Các trường hợp sau khi nộp bài tập.</p>
                    <p>Có % tỉ lệ điểm, icon bài tập có màu xanh lá cây => Bài tập đã được chấm và đã vượt qua điểm chuẩn.</p>
                    <p>Có % tỉ lệ điểm, icon bài tập có màu đỏ => Bài tập đã được chấm nhưng chưa vượt qua điểm chuẩn.</p>
                    <p>Chưa có % tỉ lệ điểm, icon bài tập có màu đỏ => Bài tập đã được gửi chấm và đang chờ chấm điểm.</p>
                    <p>Nếu icon bài tập có màu đen => chưa làm bài tập, hoặc đã làm nhưng chưa nộp bài.</p>
                    <p>① Để xem lại đáp án bài tập, học viên có thể nhấn vào % Tỷ lệ điểm ở cột Tỷ lệ điểm của bài học tương ứng.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_14.png" alt="" /></div>
                <div>
                    <p>② Những câu có màu xanh lá cây là những câu trả lời đúng. Những câu có màu cam là những câu tra lời sai. Học viên có thể xem chi tiết nội dung và đáp án tứng câu bằng cách nhấn vào các số câu hỏi, hoặc nhấn vào các nút [Về trước], [Đi tiếp].</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_15.png" alt="" /></div>
                <div id="vn-10">
                    <h1>10. Quay lại</h1>
                </div>
                <div>
                    <p>※ Để quay lại màn hình mục lục nhấn vào nút quay lại trên nội dung bài học.</p>
                </div>
                <div><img src="/static\images\vi\newManual\lesson_content_16.png" alt="" /></div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div id="vn-1">
                    <h1>1. Bắt đầu khoá học</h1>
                </div>
                <div>
                    <p>① Chọn một khóa học bạn muốn học.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_1.png" alt="" /></div>
                <div>
                    <p>※ Sau khi tìm được khóa học mà bạn muốn học, thì nhấn vào khóa học đó để di chuyển đến màn hình khái quát khóa học.</p>
                    <p>② Ở màn hình Khái quát khóa học, nhấn nút [Bắt đầu], di chuyển đến màn hình [Mục lục khóa học].</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_2.png" alt="" /></div>
                <div id="vn-2">
                    <h1>2. Chọn bài học</h1>
                </div>
                <div>
                    <p>① Nhấn vào 1 bài học trong Mục lục bài học, rồi học nội dung bài học đó.</p>
                    <p>※ Icon quyển sách bên tên bài học hiển thị màu đen là chưa học, màu đỏ là đang học và mày xanh là đã học xong bài.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_3.png" alt="" /></div>
                <div id="vn-3">
                    <h1>3. Di chuyển nội dung lên・xuống</h1>
                </div>
                <div>
                    <p>※ Trường hợp hình ảnh hiển thị không hết trong trang bạn có thể chọn thanh bên phải để di chuyển lên hoặc xuống để xem ảnh.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_4.png" alt="" /></div>
                <div id="vn-4">
                    <h1>4. Phóng to/Thu nhỏ</h1>
                </div>
                <div>
                    <p>※ Trường hợp không thể nhìn thấy rõ thông tin hình ảnh, bạn có thể phóng to hoặc thu nhỏ ở icon phía trên.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_16.png" alt="" /></div>
                <div id="vn-5">
                    <h1>5. Ghi chú</h1>
                </div>
                <div>
                    <p>① Nhấn vào icon [Mục lục] ở thanh menu bên dưới màn hình.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_5.png" alt="" /></div>
                <div>
                    <p>② Chọn phần ghi chú.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_6.png" alt="" /></div>
                <div>
                    <p>③ Điền nội dung cần ghi chú.</p>
                    <p>④ Sau khi hoàn tất việc ghi chú hãy nhấn nút [lưu].</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_7.png" alt="" /></div>
                <div id="vn-6">
                    <h1>6. Trao đổi ý kiến</h1>
                </div>
                <div>
                    <p>① Nhấn vào icon [Mục lục] ở thanh menu bên dưới màn hình.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_5.png" alt="" /></div>
                <div>
                    <p>② Chọn phần trao đổi.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_8.png" alt="" /></div>
                <div>
                    <p>③ Tại đây bạn có thể gửi câu hỏi liên quan đến bài học đang học cho giáo viên.</p>
                    <p>※ Ngoài gửi câu hỏi cho giáo viên còn xem được nội dung trao đổi của các học viên khác về nội dung bài học liên quan.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_9.png" alt="" /></div>
                <div id="vn-7">
                    <h1>7. Di chuyển trang</h1>
                </div>
                <div>
                    <p>※ Nhấn icon [Về trước], [Đi tiếp] để di chuyển để trang tiếp theo hoặc quay lại trang trước.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_17.png" alt="" /></div>
                <div id="vn-8">
                    <h1>8. Làm bài tập</h1>
                </div>
                <div>
                    <p>※ Lưu ý: Phải xem hết tất cả nội dung của bài học thì mới có thể làm bài tập của bài học đó. Nếu chưa hoàn thành nội dung bài học mà nhấn vào icon [Bài tập], hộp thoại cảnh báo sẽ xuất hiện.</p>
                    <p>① Biểu tượng Bài tập sẽ được hiển thị ở cột Bài tập trong mỗi bài học. Khi nhấn biểu tượng Bài tập, thì sẽ di chuyển đến màn hình làm Bài tập.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_11.png" alt="" /></div>
                <div>
                    <p>② Hoặc có thể làm bài tập từ trang bài học cụ thể bằng cách nhấn vào biểu tượng Bài tập ở góc phải phải phía trên màn hình.</p>
                    <p>※ Nếu không có biểu tượng bài tập thì có nghĩa là bài học đó không có bài tập.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_12.png" alt="" /></div>
                <div>
                    <p>③ Nhấn nút nộp bài để nộp bài luyện tập.</p>
                    <p>④ Nút icon [Đáp án] được hiển thị khi giáo viên set cho bạn xem được đáp án của bài luyện tập đó.</p>
                    <p>⑤ Chọn đáp án đúng vào câu hỏi bạn cần trả lời.</p>
                    <p>⑥ Hiển thị danh sách câu hỏi. Câu đang có viền màu đỏ là câu hiện tại bạn đang làm. Câu được tô màu xanh là những câu bạn đã điền đáp án.</p>
                    <p>⑦ Nhấn icon [Đi tiếp], [về tiếp] để di chuyển câu tiếp theo hoặc quay lại câu hỏi trước.</p>
                    <p>⑧ Nhấn icon [Quay lại] để di chuyển về màn hình mục lục của khoá học.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_13.png" alt="" /></div>
                <div id="vn-9">
                    <h1>9. Xem điểm bài tập</h1>
                </div>
                <div>
                    <p>※ Các trường hợp sau khi nộp bài tập.</p>
                    <p>Có % tỉ lệ điểm, icon bài tập có màu xanh lá cây => Bài tập đã được chấm và đã vượt qua điểm chuẩn.</p>
                    <p>Có % tỉ lệ điểm, icon bài tập có màu đỏ => Bài tập đã được chấm nhưng chưa vượt qua điểm chuẩn.</p>
                    <p>Chưa có % tỉ lệ điểm, icon bài tập có màu đỏ => Bài tập đã được gửi chấm và đang chờ chấm điểm.</p>
                    <p>Nếu icon bài tập có màu đen => chưa làm bài tập, hoặc đã làm nhưng chưa nộp bài.</p>
                    <p>① Để xem lại đáp án bài tập, học viên có thể nhấn vào % Tỷ lệ điểm ở cột Tỷ lệ điểm của bài học tương ứng.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_14.png" alt="" /></div>
                <div>
                    <p>② Những câu có màu xanh lá cây là những câu trả lời đúng. Những câu có màu cam là những câu tra lời sai. Học viên có thể xem chi tiết nội dung và đáp án tứng câu bằng cách nhấn vào các số câu hỏi, hoặc nhấn vào các nút [Về trước], [Đi tiếp].</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_18.png" alt="" /></div>
                <div id="vn-10">
                    <h1>10. Quay lại</h1>
                </div>
                <div>
                    <p>※ Để quay lại màn hình mục lục nhấn vào nút quay lại trên nội dung bài học.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\lesson_content_mb_15.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        props: {
            data: {
                type: Object,
                default: {}
            },
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        created() {
            if (this.data.type==31||this.data.type==8) {
                this.scrollToElement('vn-1');
            }
            if (this.data.type==32) {
                this.scrollToElement('vn-2');
            }
            if (this.data.type==33) {
                this.scrollToElement('vn-3');
            }
            if (this.data.type==34) {
                this.scrollToElement('vn-4');
            }
            if (this.data.type==35) {
                this.scrollToElement('vn-5');
            }
            if (this.data.type==36) {
                this.scrollToElement('vn-6');
            }
            if (this.data.type==37) {
                this.scrollToElement('vn-7');
            }
            if (this.data.type==38) {
                this.scrollToElement('vn-8');
            }
            if (this.data.type==39) {
                this.scrollToElement('vn-9');
            }
            if (this.data.type==40) {
                this.scrollToElement('vn-10');
            }
        },
        watch: {},
        methods: {
            scrollToElement(id) {
                setTimeout(() => {
                    let element = document.getElementById(id);
                    element.scrollIntoView();
                }, 100);
                
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/lessonContent_manual.vue